console.log("%c"+'\n'
+"                                                                                                   '                                           '                                             "+'\n'
+"                                                                                               '             '                                                             )`·.          "+'\n'
+"                  /(      .·´( )`·.                          (`·.                )\\            '            (`·.               )\\'                             /(      .·´    (          "+'\n'
+"          )\\      )  `·._):::.....::)         '’               )  `·.   .·´( .·´  (     /(     '             )  `·.   .·´( .·´  (     /('             )\\      )  `·._):::.    )        '’"+'\n'
+"    )\\ .·´ .:`·.(:;;  --  ' '\\:. :(.·´)    )\\           .·´( .·´:..::(,(::--  ’ \\::.`·._) `·.        .·´( .·´:..::(,(::--  ' '\\::.`·._) `·.’    )\\ .·´ .:`·.(:;;  --  ' '\\:. :(.·´)    )\\ "+'\n'
+".·´  (,): --  ' '              \\....:::`·./:.:\\)`·.     );; :--  ' '             _\\::....:::::)’(     );; :--   '               \\::....:::::).·´  (,): --  ' '              \\....:::`·.(  ("+'\n'
+"):.::/\\                 ,..::´/:::......::::·´.::(  .·´/\\                ,..:´:::::'/ `  · :/;·´  .·´/\\                ,...__ ¯¯¯` ·:·´’):.::/\\                        ¯¯¯` · ::·´’"+'\n'
+"`·:/::::\\...:´/       /:::::/¯¯¯¯/:::/¯¯¯¯/   )/:::'\\...:´/       /::::::::::/        /     )/:::'\\...:´/       /:::::::::::/     /   `·:/::::\\...:´/       ____          \\     "+'\n'
+"   \\::::/::::/      /;::·´'/       / ·:/       / '    \\:::/::::/       /;;:::·  ´ /        '/       \\:::/::::/       /;;::;;´-··´´     /  '  \\::::/::::/      /::::::::/I        /    ’'"+'\n'
+"     \\/;::-'/      /     '/       /   /       /        '\\/;::-'/       /,  -·· ' '          /     '    '\\/;::-'/               ,...::::´/     '   \\/;::-'/      /::::::::/:/       /'      "+'\n'
+"          /      /     '/       /   /       /  '            /        ,...-:::: ´'/       '/   '            /       ,, -,      \\::::::/    '             /      /¯¯¯¯¯'I/        /''       "+'\n'
+"        '/      /     '/       /   /       /         .·´( '/       /::::::::::::/       '/   '      .·´( '/       /:::/::\\      \\:· ´                 '/      /       /        /         '"+'\n'
+"       /I      'I    '/       /   /       /   '     _) ::/____/;;::::: - ´/        /      ’  _) ::/       '/;;:/::::'\\      '\\          ’'       /I     'I      /        /'      '    "+'\n'
+"     /:/::·.,   `·,/        `·,/       /          `·:::/:::::::/.  - ··  ´´       .·´/    '     )..::/       /    '\\::::::'\\      '\\              /::/`· ,   `·,_'/       /’            "+'\n'
+"    I/:::::::::*·.___ .·:/:·._..-:´/              )/::; - '          ..-:::::'/:::/       '   `·:/___/       '\\::::::\\____\\           I:/::::::::` · ,___,.·:/'             '"+'\n'
+"     `·-:;::::::/:::::/::/:::'/:/::::/       '         ¯/::`*..¸..-::::::::::::/:·´            ' /::::::::/           '\\::::/:::::::/            `·:;::::::::::/:::::/:::/'      '    "+'\n'    
+"           '*·:/:::::/:·´ *·:/:/::-·´                 /:::::::/::::::::::-·· ´´               ' /::::::::/              '\\/:::::::'/     '             ` ·:;:::/:::::/;·´'             '   "+'\n'
+"               ¯¯¯         ¯                       `*-::;/::::-·· '’                         ¯¯¯¯¯                 ¯¯¯¯          ’                 ¯¯¯ ’                     "+'\n',"background-color:#fff;color:#e84702;font-family:sans-serif")

var RootView = Mn.View.extend({
	template:_.template($("#tmpl-site-root").html())
	,regions: function() {
		return {
			 systemMessagesRegion : "#system-messages-region"
			,mainRegion           : "#main-region"
			,dialogRegion         : "#dialog-region"
		};
	}
});

var APP = new Marionette.Application({
	region:'#root'
	//could also use APP.on("start",function(){})
	,onStart:function(){
		console.log("APP Start")
		var that = this;

		/* 
			Global Settings
			We might want to wrap this into a radio call at some point
		*/
		Backbone.settings = Backbone.settings||{};
		Backbone.settings.flags = {
			 pledgeDrive:false
			,volunteer:false
			,callcenter:false
		}
		
		// note use of 'always'. We want to continue even if the request fails
		$.when( Backbone.Radio.channel('utilities').request('pledgeAdminData') ).always(function(pledgeadminData){
			if( pledgeadminData &&
				pledgeadminData.Begin_Pledge &&
				pledgeadminData.End_Pledge &&
				moment(pledgeadminData.Begin_Pledge).isValid() && 
				moment(pledgeadminData.End_Pledge).isValid()
			){
				// 'day' makes the comparison happen on the day level, instead of milliseconds
				// The '[]' makes the comparison inclusive, so the first/last days count
				if( moment().isBetween(pledgeadminData.Begin_Pledge, pledgeadminData.End_Pledge, 'day', '[]') ){
					Backbone.settings.flags.pledgeDrive=true;
				}
			}
			
			var p = Backbone.Radio.channel('utilities').request('querystring-parse');
			if(p.t && p.t =='pledge'){    Backbone.settings.flags.pledgeDrive = true }
			if(p.t && p.t =='volunteer'){ Backbone.settings.flags.volunteer = true }
			if(p.t && p.t =='pronto'){    Backbone.settings.flags.callcenter = true }
			if(p.t && p.t =='callcenter'){Backbone.settings.flags.callcenter = true }
			Backbone.settings.qs = p;
	
			that.showView(new RootView())
			if(!Backbone.history.start({pushState: true})){
				//all logged in users should have APPS.profile, so this is a substitute for our php var $logged_in
				if(typeof APPS.profile === 'undefined'){
					//Lots of pages that can't be accessed until after login don't have routes available yet. 
					//	Check a few before throwing a 404.
					var routes = [
						 "/my/transactions"
						,"/my/quickpledge"
						,"/my/contact"
						,"/my/address"
						,"/my/payment"
					];
					var found = false;
					_.each(routes,function(r){
						if(window.location.pathname==="/my/" || window.location.pathname.startsWith(r)){
							found=true;
						}
					})
					if(found){
						window.location.href = APP_CONFIG.LOGIN_SITE_URL+'/login?returnurl='+APP_CONFIG.MEMBERS_SITE_URL+Backbone.history.getFragment();
						return; 
					} 
				} 
				Backbone.Radio.channel('404').request("show");					
				
			}
		});
	}
});

